import { showPaymentDetailsForUser, isCurrentUserSeller } from './userHelpers';

/**
 * Sentinel `currentPage` when no account sub-route is active (customer dashboard overview).
 */
export const CUSTOMER_SIDEBAR_NO_ACCOUNT_PAGE = 'CustomerDashboardPage';

/**
 * True when the signed-in user should see the customer hub (buyers, not sellers).
 *
 * @param {Object} config
 * @param {Object|null} currentUser
 * @returns {boolean}
 */
export const isCustomerHubUser = (config, currentUser) =>
  !!currentUser?.id && !isCurrentUserSeller(config, currentUser);

/**
 * Props for embedded account nav under the customer sidebar Settings group.
 *
 * @param {Object} config
 * @param {Object} currentUser
 * @param {string} [activeAccountPage]
 */
export const getCustomerEmbeddedAccountNavProps = (config, currentUser, activeAccountPage) => {
  const { showPayoutDetails, showPaymentMethods } = showPaymentDetailsForUser(config, currentUser);
  return {
    currentPage: activeAccountPage || CUSTOMER_SIDEBAR_NO_ACCOUNT_PAGE,
    showPaymentMethods,
    showPayoutDetails,
  };
};
